export default __webpack_public_path__ + "static/media/health1.87c69372.png";